<div id="global-search-bar">
  <div class="search-input">
    <mat-form-field appearance="outline" class="reset-outline-hint filter-field search">
      <input
        #searchInputField
        #searchInputAutocompleteTrigger="matAutocompleteTrigger"
        (input)="searchInputAutocompleteTrigger.closePanel()"
        matInput
        [(ngModel)]="filter"
        attr.aria-label="{{ 'global_search_filter' | translate }}"
        attr.aria-label="{{ 'label_table_filter' | translate }}"
        (debounceFilterInput)="applyFilterTable($event)"
        [debounceTime]="0"
        placeholder="{{ 'global_search_filter_placeholder' | translate }}"
        (keydown.enter)="doSearch()"
        (mousedown)="$event.stopPropagation(); $event.preventDefault()"
        [matAutocomplete]="autoLastStringOption"
        (click)="$event.target.select()"
        [disabled]="isDisabled"
      />
      @if (enableSearch && !isDisabled) {
        <button mat-icon-button (click)="$event.stopPropagation(); doSearch()" matSuffix>
          <mat-icon>search</mat-icon>
        </button>
      }
      <mat-autocomplete
        (opened)="matAutocompletPanelOpened()"
        (closed)="matAutocompletPanelClosed()"
        #autoLastStringOption="matAutocomplete"
        (optionSelected)="applyFilterTable($event.option.value); doSearch()"
      >
        @for (opt of lastSearchOptions; track opt) {
          <mat-option class="form-field-option" [value]="opt" [class.mat-selected]="filter === opt">
            {{ opt }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
</div>
